/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { MutationTree } from 'vuex';
import * as types from '@/store/types';
import { ErrorLevel, ErrorState } from '@/store/errors/models';

export const mutations: MutationTree<ErrorState> = {
  [types.MUTATE_SET_ERROR](state, payload: ErrorState) {
    let { error } = payload;

    if (payload.error) {
      error = payload.error.replace(/\n/g, '').trim();
    }

    state.error = error;
    state.level = payload.level;

    if (payload.level === ErrorLevel.ERROR) {
      state.service = payload.service;
    }
  },
};
